import { render, staticRenderFns } from "./ExerciseAdd.vue?vue&type=template&id=469f48d2&scoped=true&"
import script from "./ExerciseAdd.vue?vue&type=script&lang=ts&"
export * from "./ExerciseAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ExerciseAdd.vue?vue&type=style&index=0&id=469f48d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469f48d2",
  null
  
)

export default component.exports